// @ts-nocheck
import { FieldModel } from '@cibo/core'
import { Grid, Stack, Typography } from '@mui/material'
import { GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { pluck, sum, uniq } from 'ramda'

interface ProgramColumnFunctionProps {
  programId: string
  t: TFunction
}

export const fieldProgramOpportunityColumn = ({ programId, t }: ProgramColumnFunctionProps) => ({
  field: 'opportunity',
  headerName: t('opportunity'),
  flex: 1,
  minWidth: 220,
  valueGetter: (params: GridValueGetterParams<string, FieldModel>) => {
    const credits = params.row.programCreditPerAcrePotential(programId)
    const dollars = params.row.programDollarPerAcrePotential(programId)

    return {
      credits: sum(pluck('credits', credits).filter(v => !!v) as number[]) * params.row.acres,
      creditYears: uniq(pluck('year', credits)),
      dollars: sum(pluck('value', dollars).filter(v => !!v) as number[]) * params.row.acres,
      dollarYears: uniq(pluck('year', dollars)),
    }
  },
  renderCell: (
    params: GridRenderCellParams<
      { dollars: number; credits: number; creditYears: number[]; dollarYears: number[] },
      FieldModel
    >
  ) => {
    const { row: field, value } = params
    const years = uniq(pluck('year', field.programPerAcrePotential(programId) || []))

    if (value === undefined) {
      return '--'
    }
    const creditStart = years.findIndex(y => y === value.creditYears[0]) + 1
    const creditEnd =
      years.findIndex(y => y === value.creditYears[value.creditYears.length - 1]) + 1
    const dollarStart = years.findIndex(y => y === value.dollarYears[0]) + 1
    const dollarEnd =
      years.findIndex(y => y === value.dollarYears[value.dollarYears.length - 1]) + 1

    return (
      <Grid container>
        <Grid xs={6} item>
          {value.dollars > 0 ? (
            <Stack>
              <Typography variant="body2">
                {t('dollarsAmount', { dollars: value.dollars })}
              </Typography>
              {dollarStart !== dollarEnd && (
                <Typography variant="caption">
                  {t('dollarsTime', { start: dollarStart, end: dollarEnd })}
                </Typography>
              )}
            </Stack>
          ) : (
            '--'
          )}
        </Grid>
        <Grid xs={6} item>
          {value.credits > 0 ? (
            <Stack>
              <Typography variant="body2">
                {t('creditsAmount', { credits: value.credits })}
              </Typography>
              {creditStart !== creditEnd && (
                <Typography variant="caption">
                  {t('creditsTime', { start: creditStart, end: creditEnd })}
                </Typography>
              )}
            </Stack>
          ) : (
            '--'
          )}
        </Grid>
      </Grid>
    )
  },
})
